<template>
  <div>clip art</div>
</template>

<script>
export default {};
</script>

<style></style>
